<ng-container *ngLet="{
    code: code$ | async,
    page: page$ | async
} as info">
    <mat-card [ngSwitch]="info?.code">
        <span *ngIf="!!info?.page">
            <ng-container *ngIf="info?.page?.translationKey as key">
                {{ key | translate }}:
            </ng-container>
        </span>
        <span *ngIf="message$ | async as message">
            {{ message }}
        </span>
    </mat-card>
</ng-container>
